import css from '@styled-system/css';

const base = css({
  position: 'relative',
  overflow: 'hidden',
  height: 0,
  borderRadius: 4,
  backgroundColor: 'neutral.40',
});

export default base;
